// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7576) return "static/chunks/7576.e4121e5d2e110e73.js";
	if (chunkId === 2387) return "static/chunks/2387.9041142a55a5a3c4.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5882 ? "543367cc" : chunkId) + "-" + {"1956":"ddcbce3b046a60a6","3972":"6685500e3aa89946","4004":"089600dde3ac820e","5882":"2b5034dccb021495"}[chunkId] + ".js";
};